import React from 'react';
import './AboutSection.css';

// Substitute with your actual local classroom/campus image asset when ready
import aboutImg from '../Images/about-classroom.jpeg'; 
import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="about-section-wrapper" id="about">
      <div className="about-container">
        
        {/* Left Side: Content & Vision/Mission Cards */}
        <div className="about-content-block">
          <span className="about-tag">ABOUT CDOE</span>
          <h2 className="about-heading">
            Empowering Education Through <br /> Distance Learning
          </h2>
          
          <p className="about-paragraph">
            The Centre for Distance and Online Education (CDOE) at EDULEARNER has been a pioneer 
            in providing quality higher education through the distance mode since its establishment. 
            Located in Thiruvannamalai, India, we serve students across India and abroad.
          </p>
          
          <p className="about-paragraph">
            Our programs are designed to offer flexibility without compromising on academic rigor. 
            With a network of over 280 study centres, state-of-the-art digital learning resources, 
            and an experienced faculty, we ensure every student receives the best possible education.
          </p>

          {/* Cards Group */}
          <div className="vision-mission-grid">
            <div className="info-card">
              <h3>Our Vision</h3>
              <p>To be a premier centre for distance education fostering knowledge, skills, and values.</p>
            </div>
            
            <div className="info-card">
              <h3>Our Mission</h3>
              <p>Providing accessible, quality education to learners at their doorstep through innovative methods.</p>
            </div>
          </div>

          {/* Action Link */}
            <Link 
              to="/about" className="about-learn-more">
            Learn More About CDOE <span className="arrow-icon">➔</span>
          </Link>
        </div>

        {/* Right Side: Framed Image Graphic Showcase */}
        <div className="about-graphic-block">
          {/* Subtle underlying background accent framework block */}
          <div className="graphic-bg-accent"></div>
          
          {/* Main Display Image */}
          <div className="image-container">
            <img 
              src={aboutImg} 
              alt="Classroom and presentation setting" 
              className="about-main-image"
            />
          </div>

          {/* Overlapping Floating NAAC Badge Block */}
          <div className="floating-naac-badge">
            <h4 className="naac-title">NAAC</h4>
            <div className="naac-grade">A++ Grade</div>
            <p className="naac-subtitle">Accredited University</p>
          </div>
        </div>

      </div>
    </section>
  );
}